import { useInstallationContext } from '../../../../context/installation';
import { ROUTES } from '../../../../routes/routes';
import { useExalusServicesContext } from '../../../../integrations/exalus/context/services';
import { removeExalusCredentials } from '../../../../integrations/exalus/utils';

export const useLogoutExalus = () => {
  const { sessionApi } = useExalusServicesContext();
  const { selectedInstallationId } = useInstallationContext();

  const handleLogoutExalus = async () => {
    await sessionApi.UserLogOutAsync();
    if (selectedInstallationId) removeExalusCredentials(selectedInstallationId);

    location.href = ROUTES.Installation();
  };

  return {
    handleLogoutExalus,
  };
};
